import DisplayPage from "sonometer/components/DisplayPage";

export function SonometerScreencastView() {
  return (
    <div className="min-h-screen bg-psg-blue">
      <DisplayPage />
    </div>
  );
}
